import React, { useEffect, useState } from 'react'
import CryptoJS from 'crypto-js'
import { EncKeys } from '../../../config'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    createPaymentRequestData,
    verifyOTP,
} from '../../redux/actions/ComponentCallsActions'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import {
    Card,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material'
import { PersonPin } from '@mui/icons-material'
import { alertService } from '../../services/alert-service'
import VerifyOTP from '../../components/OTPVerification/VerifyOTP'
import axios from 'axios'
import { MicroservicesBaseUrl } from '../../../config'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    backDrop: {
        '&.MuiBackdrop-root': {
            zIndex: 10000,
        },
    },
    progress: {
        '&.MuiCircularProgress-root': {
            color: '#ffffff',
        },
    },
}))

const AxisPage = (props) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const [openOTP, setOpenOTP] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [axisState, setAxisState] = useState({
        isSavedCard: false,
        isNewCard: true,
        cvv: '',
        cardHolder: '',
        cardNumber: '',
        saveNewCard: false,
        savedCvv: '',
        month: '',
        year: '',
    })
    // let UDF4='Transaction'
    const paymentData = useSelector((state) => state.customerData)
    const cardData = useSelector((state) => state.cardData)
    const [showSavedCards, setShowSavedCards] = useState(
        paymentData.customerData.PaymentRequest.UDF4 === 'Transaction'
            ? true
            : false
    )
    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
    const [objectsWithToken, setObjectsWithToken] = useState([])
    const [selectedCard, setSelectedCard] = useState('')
    const [cardYears, setcardYears] = useState([])
    const [month, setMonth] = useState(false)
    const [year, setYear] = useState(false)
    const [savedCard, setSavedCard] = useState('')
    const [tokenId, setTokenId] = useState('')

    const handleCloseOTP = () => {
        setOpenOTP(false)
    }

    const handleMonthChange = ({ target: { name, value } }) => {
        let temp = { ...axisState }
        temp.month = value
        setAxisState(temp)
        if (value === '' || value === undefined) {
            setMonth(false)
        } else {
            setMonth(true)
        }
    }

    const handleYearChange = ({ target: { name, value } }) => {
        let temp = { ...axisState }
        temp.year = value
        setAxisState(temp)
        if (value === '' || value === undefined) {
            setYear(false)
        } else {
            setYear(true)
        }
    }

    const handleChange = ({ target: { name, value } }) => {
        if (name === 'savedCard') {
            setSelectedCard(value)
            const selectedObject = objectsWithToken.find(
                (obj) => obj.Id === parseInt(value, 10)
            )
            // console.log(selectedCard)
            // console.log('Selected Card:',selectedObject.Card);
            setSavedCard(selectedObject.Card)
            setTokenId(selectedObject.TokenId)
        } else if (name === 'cardHolder') {
            const alphaValue = value.replace(/[^a-zA-Z\s]/g, '')
            let temp = { ...axisState }
            temp.cardHolder = alphaValue
            setAxisState(temp)
        } else if (name === 'cvv') {
            const number = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.cvv = number
            setAxisState(temp)
        } else if (name === 'cardNumber') {
            const filteredValue = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.cardNumber = filteredValue
            setAxisState(temp)
        } else if (name === 'savedCvv') {
            const number = value.replace(/[^0-9]/g, '')
            let temp = { ...axisState }
            temp.savedCvv = number
            setAxisState(temp)
        } else {
            let temp = { ...axisState }
            temp[name] = value
            setAxisState(temp)
        }
    }
    const getCardYear = () => {
        let years = []
        for (let i = 0; i < 10; i++) {
            let value = new Date().getFullYear() + i
            let text = new Date().getFullYear() + i + ''
            years.push({ value: value, text: text })
        }

        let tempYear = [...years]
        setcardYears(tempYear)
    }

    const submitSavedCardRequest = () => {
        let Cvv = ''
        if (showSavedCards === false) {
            alertService.addError('No card registered for transaction')
            return false
        }
        let CVV = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(axisState.savedCvv.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        Cvv = CVV
        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'razorpay',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            Cvv: Cvv.toString(),
            ExpiryMonth: '',
            ExpiryYear: '',
            CardHolderName: '',
            CardNo: savedCard.toString(),
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
            Email: '',
            Contact: '',
            TokenId: tokenId,
            IsCardDetailSaved: showSavedCards,
            IsNewCardDetailSave: showSavedCards === false ? true : false,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }
        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        setIsLoading(false)
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        localStorage.setItem('gateway', 'razorpay')
                        let actualResponse = JSON.parse(decrypted)
                        history.push({
                            pathname: '/TransactionStatus',
                            state: actualResponse,
                        })
                    } else {
                        setIsLoading(false)
                        const transactionResponse = {
                            Comments: res.errorMessage,
                            Status: 'Transaction declined',
                            TransactionId: '',
                            TrackId: '',
                            Amount: '',
                            TransactionDate: '',
                            RedirectUrl:
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl,
                        }
                        history.push({
                            pathname: '/TransactionStatus',
                            state: transactionResponse,
                        })
                    }
                },
                (err) => {
                    setIsLoading(false)
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }

    const submitRequest = async () => {
        let Cvv = ''
        if (showSavedCards === true) {
            if (tokenId === '' || tokenId === undefined) {
                alertService.addError('Please select card to make transaction')
                return false
            }
            const payload = {
                PhoneNumber:
                    paymentData.customerData.PaymentRequest.PhoneNumber,
                Module: 'Axis Transaction',
                IsResend: false,
            }
            const jsonBody = JSON.stringify(payload)
            let EncPayload = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(jsonBody.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )
            let postData = {
                payload: EncPayload.toString(),
            }

            try {
                setIsLoading(true)
                const headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin':
                        MicroservicesBaseUrl.webBaseUrl,
                }
                let url =
                    MicroservicesBaseUrl.baseApiUrl + 'api/OTP/GenerateOTP'
                const request = {
                    method: 'post',
                    headers: headers,
                    url: url,
                }
                request['data'] = postData || {}
                axios(request)
                    .then((response) => {
                        if (response && response.data) {
                            if (response.data.statusCode === 200) {
                                setIsLoading(false)
                                setOpenOTP(true)
                            } else {
                                setIsLoading(false)
                                alertService.addError(response.errorMessage)
                            }
                        }
                    })
                    .catch((error) => {
                        alertService.addError(
                            'Something went wrong, Please try again later'
                        )
                    })
                    .finally(() => {
                        setIsLoading(false)
                    })
            } catch (error) {
                setIsLoading(false)
                alertService.addError(
                    'Something went wrong, Please try again later'
                )
            }
        } else {
            let CardNumber = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(axisState.cardNumber.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )
            let CVV = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(axisState.cvv.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )
            Cvv = CVV
            let ExpMonth = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(axisState.month.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )
            let ExpYear = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(axisState.year.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )
            const postRequest = {
                CustomerPaymentReqID:
                    paymentData.customerData.PaymentRequest.Id,
                AgentID: paymentData.customerData.PaymentRequest.ClientId,
                PaymentOption: 'razorpay',
                TrackId: paymentData.customerData.PaymentRequest.TrackID,
                TotalAmount: paymentData.customerData.PaymentRequest.Amount,
                // TotalAmount: 200,
                Cvv: Cvv.toString(),
                ExpiryMonth: ExpMonth.toString(),
                ExpiryYear: ExpYear.toString(),
                CardHolderName: axisState.cardHolder,
                CardNo: CardNumber.toString(),
                UDF1: paymentData.customerData.PaymentRequest.UDF1,
                UDF2: paymentData.customerData.PaymentRequest.UDF2,
                UDF3: paymentData.customerData.PaymentRequest.UDF3,
                UDF4: paymentData.customerData.PaymentRequest.UDF4,
                UDF5: paymentData.customerData.PaymentRequest.UDF5,
                Email: '',
                Contact: '',
                TokenId: '',
                IsCardDetailSaved: showSavedCards,
                IsNewCardDetailSave: showSavedCards === false ? true : false,
            }
            const jsonBody = JSON.stringify(postRequest)

            let encryptedPostRequest = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(jsonBody.toString()),
                key,
                {
                    keySize: 128 / 8,
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7,
                }
            )

            let postData = {
                payload: encryptedPostRequest.toString(),
            }
            dispatch(
                createPaymentRequestData(
                    postData,
                    (res) => {
                        if (res.statusCode === 200) {
                            const decryptedResponse = CryptoJS.AES.decrypt(
                                res.data,
                                key,
                                {
                                    keySize: 128 / 8,
                                    iv: iv,
                                    mode: CryptoJS.mode.CBC,
                                    padding: CryptoJS.pad.Pkcs7,
                                }
                            )
                            const decrypted = decryptedResponse.toString(
                                CryptoJS.enc.Utf8
                            )
                            localStorage.setItem('gateway', 'razorpay')
                            localStorage.setItem(
                                'encCardNo',
                                CardNumber.toString()
                            )

                            let actualResponse = JSON.parse(decrypted)
                            history.push('/RazorPay', {
                                responseData: actualResponse,
                            })
                        } else {
                            const transactionResponse = {
                                Comments: res.errorMessage,
                                Status: 'Transaction declined',
                                TransactionId: '',
                                TrackId: '',
                                Amount: '',
                                TransactionDate: '',
                                RedirectUrl:
                                    paymentData.customerData.PaymentRequest
                                        .RedirectUrl,
                            }
                            history.push({
                                pathname: '/TransactionStatus',
                                state: transactionResponse,
                            })
                        }
                    },
                    (err) => {
                        const transactionResponse = {
                            Comments:
                                'Please Contact Vayana Team for further details',
                            Status: 'Transaction declined',
                            TransactionId: '',
                            TrackId: '',
                            Amount: '',
                            TransactionDate: '',
                            RedirectUrl:
                                paymentData.customerData.PaymentRequest
                                    .RedirectUrl,
                        }
                        history.push({
                            pathname: '/TransactionStatus',
                            state: transactionResponse,
                        })
                    }
                )
            )
        }
    }
    const SubmitOTP = (event) => {
        const payload = {
            PhoneNumber: paymentData.customerData.PaymentRequest.PhoneNumber,
            Module: 'Axis Transaction',
            OTP: event.enteredOtp,
        }
        const jsonBody = JSON.stringify(payload)
        let EncPayload = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        let postData = {
            payload: EncPayload.toString(),
        }
        setIsLoading(true)

        dispatch(
            verifyOTP(postData, (res) => {
                if (res.statusCode === 200) {
                    submitSavedCardRequest()
                } else {
                    setIsLoading(false)
                    alertService.addError(res.errorMessage)
                    return false
                }
            })
        )
    }

    const resendOtpSubmilt = () => {
        let Cvv = ''
        const payload = {
            PhoneNumber: paymentData.customerData.PaymentRequest.PhoneNumber,
            Module: 'Axis Transaction',
            IsResend: true,
        }
        const jsonBody = JSON.stringify(payload)
        let EncPayload = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        let postData = {
            payload: EncPayload.toString(),
        }
        try {
            setIsLoading(true)
            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': MicroservicesBaseUrl.webBaseUrl,
            }
            let url = MicroservicesBaseUrl.baseApiUrl + 'api/OTP/GenerateOTP'
            const request = {
                method: 'post',
                headers: headers,
                url: url,
            }
            request['data'] = postData || {}
            axios(request)
                .then((response) => {
                    if (response && response.data) {
                        if (response.data.statusCode === 200) {
                            setIsLoading(false)
                            alertService.addSuccess('OTP resend successfully.')
                        } else {
                            setIsLoading(false)
                            alertService.addError(response.errorMessage)
                        }
                    }
                })
                .catch((error) => {
                    alertService.addError(
                        'Something went wrong, Please try again later'
                    )
                })
                .finally(() => {
                    setIsLoading(false)
                })
        } catch (error) {
            setIsLoading(false)
            alertService.addError(
                'Something went wrong, Please try again later'
            )
        }
    }
    const handleBack = () => {
        props.onBackBtnClick()
    }

    const handleSavedCardClick = async () => {
        if (objectsWithToken.length <= 0) {
            await delay(300)
            alertService.addError(
                'No card registered for ' +
                    paymentData.customerData.PaymentRequest.PaymentCategory +
                    ' payment'
            )
            return false
        }
    }

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

    useEffect(() => {
        getCardYear()
        if (
            typeof cardData.cardData === 'object' &&
            Object.keys(cardData.cardData).length > 0
        ) {
            // Filter the object to get objects with non-null TokenId
            const filteredObjects = Object.values(cardData.cardData).filter(
                (obj) => obj.TokenId !== null
            )
            setObjectsWithToken(filteredObjects)
            let temp = { ...axisState }
            temp.isSavedCard = true
            temp.isNewCard = false
            setAxisState(temp)
        } else {
            let temp = { ...axisState }
            temp.isSavedCard = false
            temp.isNewCard = true
            setAxisState(temp)
        }
        return () => {
            setObjectsWithToken([])
            setcardYears([])
        }
    }, [cardData])

    return (
        <>
            <div>
                <ValidatorForm
                    onSubmit={() => {
                        submitRequest()
                    }}
                >
                    <Card sx={{ p: 1, boxShadow: 'none' }}>
                        <Typography
                            style={{
                                padding: '10px 0px',
                            }}
                        >
                            Enter Your Card Details
                        </Typography>
                        <Grid container spacing={1}>
                            {showSavedCards === true ? (
                                <>
                                    <Grid
                                        container
                                        spacing={1}
                                        style={{
                                            marginLeft: '2px',
                                            marginTop: '10px',
                                        }}
                                    >
                                        <Grid item xs={8} md={6}>
                                            <FormControl
                                                variant="outlined"
                                                fullWidth={true}
                                                className="mb-4"
                                            >
                                                <InputLabel
                                                    style={{
                                                        marginTop: '-8px',
                                                    }}
                                                    id="cardMonthLabel"
                                                >
                                                    Select a Card
                                                </InputLabel>
                                                <Select
                                                    size="small"
                                                    name="savedCard"
                                                    labelId="cardMonthLabel"
                                                    id="card-select"
                                                    value={selectedCard}
                                                    onChange={handleChange}
                                                    onOpen={
                                                        handleSavedCardClick
                                                    }
                                                >
                                                    {objectsWithToken.map(
                                                        (obj) => (
                                                            <MenuItem
                                                                key={obj.Id}
                                                                value={obj.Id}
                                                            >
                                                                {'Card ending in ' +
                                                                    obj.Card}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4} md={6}>
                                            <TextValidator
                                                size="small"
                                                sx={{
                                                    width: '100%',
                                                    marginBottom: '22px',
                                                }}
                                                disabled
                                                onChange={handleChange}
                                                name="savedCvv"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <img
                                                                style={{
                                                                    width: '50px',
                                                                }}
                                                                src="https://cdn1.iconfinder.com/data/icons/finance-technology-fintech-vol-3/256/cvv-512.png"
                                                                alt="CVV"
                                                            />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                value={axisState.savedCvv}
                                                id="savedCVV"
                                                label="CVV"
                                                variant="outlined"
                                                onInput={(e) => {
                                                    e.target.value =
                                                        e.target.value
                                                            .toString()
                                                            .slice(0, 3)
                                                }}
                                                type="password"
                                                // validators={[
                                                //     'required',
                                                //     'minStringLength:3',
                                                // ]}
                                                // errorMessages={[
                                                //     'CVV is required',
                                                //     'CVV must be of 3 digits',
                                                // ]}
                                                FormHelperTextProps={{
                                                    color: 'red',
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Grid item xs={12}>
                                        <Typography
                                            style={{
                                                padding: '10px 0px',
                                            }}
                                        >
                                            Add A New Card :
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextValidator
                                            size="small"
                                            sx={{
                                                width: '100%',
                                                marginTop: '10px',
                                                marginBottom: '22px',
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <PersonPin />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            value={axisState.cardHolder || ''}
                                            onChange={handleChange}
                                            name="cardHolder"
                                            id="outlined-basic"
                                            label="Card Holder"
                                            variant="outlined"
                                            validators={['required']}
                                            errorMessages={[
                                                'Card Holder Name is required',
                                            ]}
                                            FormHelperTextProps={{
                                                color: 'red',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextValidator
                                            size="small"
                                            sx={{
                                                width: '100%',
                                                marginTop: '10px',
                                                marginBottom: '22px',
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <img
                                                            style={{
                                                                width: '60px',
                                                            }}
                                                            src="https://www.seekpng.com/png/detail/136-1366945_mastercard-logo-png-logo-visa-mastercard-png.png"
                                                            alt="VM"
                                                        />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            onChange={handleChange}
                                            value={axisState.cardNumber || ''}
                                            placeholder=""
                                            id="outlined-basic"
                                            label="Card Number"
                                            variant="outlined"
                                            name="cardNumber"
                                            onInput={(e) => {
                                                e.target.value = e.target.value
                                                    .toString()
                                                    .slice(0, 16)
                                            }}
                                            validators={[
                                                'required',
                                                'minStringLength:16',
                                                'matchRegexp:^[0-9]+$$',
                                            ]}
                                            errorMessages={[
                                                'Credit-Card Number Name is required',
                                                'Credit Card must be of 16 digits',
                                                'Only numbers are allowed',
                                            ]}
                                            FormHelperTextProps={{
                                                color: 'red',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl
                                            variant="outlined"
                                            fullWidth
                                            className="mb-4"
                                        >
                                            <InputLabel
                                                style={{ marginTop: '-5px' }}
                                                id="cardMonthLabel"
                                            >
                                                MM
                                            </InputLabel>
                                            <Select
                                                size="small"
                                                labelId="cardMonthLabel"
                                                id="cardMonth"
                                                label="Month"
                                                value={axisState.month || ''}
                                                validators={['required']}
                                                onChange={handleMonthChange}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Month</em>
                                                </MenuItem>
                                                <MenuItem value="1">
                                                    January - (01)
                                                </MenuItem>
                                                <MenuItem value="2">
                                                    February - (02)
                                                </MenuItem>
                                                <MenuItem value="3">
                                                    March - (03)
                                                </MenuItem>
                                                <MenuItem value="4">
                                                    April - (04)
                                                </MenuItem>
                                                <MenuItem value="5">
                                                    May - (05)
                                                </MenuItem>
                                                <MenuItem value="6">
                                                    June - (06)
                                                </MenuItem>
                                                <MenuItem value="7">
                                                    July - (07)
                                                </MenuItem>
                                                <MenuItem value="8">
                                                    August - (08)
                                                </MenuItem>
                                                <MenuItem value="9">
                                                    September - (09)
                                                </MenuItem>
                                                <MenuItem value="10">
                                                    October - (10)
                                                </MenuItem>
                                                <MenuItem value="11">
                                                    November - (11)
                                                </MenuItem>
                                                <MenuItem value="12">
                                                    December - (12)
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <FormControl
                                            variant="outlined"
                                            fullWidth
                                            className="mb-4"
                                        >
                                            <InputLabel
                                                style={{ marginTop: '-5px' }}
                                                id="cardYearLabel"
                                            >
                                                YY
                                            </InputLabel>
                                            <Select
                                                size="small"
                                                labelId="cardYearLabel"
                                                id="cardYear"
                                                label="Year"
                                                value={axisState.year || ''}
                                                validators={['required']}
                                                onChange={handleYearChange}
                                            >
                                                {cardYears.map((year) => (
                                                    <MenuItem
                                                        key={year.value}
                                                        value={year.value}
                                                    >
                                                        {year.text}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextValidator
                                            size="small"
                                            sx={{
                                                width: '100%',

                                                marginBottom: '10px',
                                            }}
                                            onChange={handleChange}
                                            name="cvv"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <img
                                                            style={{
                                                                width: '50px',
                                                            }}
                                                            src="https://cdn1.iconfinder.com/data/icons/finance-technology-fintech-vol-3/256/cvv-512.png"
                                                            alt="CVV"
                                                        />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            value={axisState.cvv || ''}
                                            id="outlined-basic"
                                            label="CVV"
                                            variant="outlined"
                                            onInput={(e) => {
                                                e.target.value = e.target.value
                                                    .toString()
                                                    .slice(0, 3)
                                            }}
                                            type="password"
                                            // validators={[
                                            //     'required',
                                            //     'minStringLength:3',
                                            // ]}
                                            // errorMessages={[
                                            //     'CVV is required',
                                            //     'CVV must be of 3 digits',
                                            // ]}
                                            // FormHelperTextProps={{
                                            //     color: 'red',
                                            // }}
                                        />
                                    </Grid>
                                </>
                            )}

                            <Grid item xs={12}></Grid>
                            <Grid item xs={12}></Grid>
                            <Grid item xs={12} md={6}>
                                <button
                                    type="button"
                                    className="backButton"
                                    style={{
                                        width: '100%',
                                        margin: '10px 0px',
                                    }}
                                    onClick={handleBack}
                                >
                                    Back
                                </button>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <button
                                    type="submit"
                                    className="btn"
                                    style={{
                                        backgroundColor:
                                            paymentData.customerData.UIConfig
                                                .ButtonBackgroundColor,
                                        color: paymentData.customerData.UIConfig
                                            .ButtonTextColor,
                                    }}
                                >
                                    Pay
                                </button>
                            </Grid>
                        </Grid>
                    </Card>
                </ValidatorForm>
            </div>
            {openOTP && (
                <VerifyOTP
                    open={openOTP}
                    onOTPCancel={handleCloseOTP}
                    onOTPSubmit={SubmitOTP}
                    onResendOTP={resendOtpSubmilt}
                />
            )}
            <Backdrop className={classes.backDrop} open={isLoading}>
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    className={classes.progress}
                    size={50}
                    thickness={5}
                    {...props}
                />
            </Backdrop>
        </>
    )
}

export default AxisPage
